'use strict';

var log = require('../../log/Log').channel('RemoteControlSessionsController');
var moment = require('moment');
var UAParser = require('ua-parser-js');
require('./RemoteControlService');

angular.module('inara')
.directive('remoteControlSessions', function() {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'remoteControlSessions.html',
        controllerAs: 'vm',
        controller: RemoteControlSessionsController
    };
})

.controller('RemoteControlSessionsController', RemoteControlSessionsController);

RemoteControlSessionsController.$inject = ['$scope', '$state', 'RoomService',
    'KayleeService', '$ionicViewSwitcher', 'gettextCatalog', '$sce',
    '$ionicScrollDelegate', '$ionicPopup', 'ViewStateService',
    'RemoteControlService'];

function RemoteControlSessionsController($scope, $state, RoomService,
    KayleeService, $ionicViewSwitcher, gettextCatalog, $sce,
    $ionicScrollDelegate, $ionicPopup, ViewStateService,
    RemoteControlService) {
    var vm = this;
    var confirmPopup = null;
    vm.filterActiveSessions = function(session) { return session.expires > Date.now(); };
    vm.formatDuration = formatDuration;
    vm.getRemoteControlCode = RemoteControlService.getRemoteControlCode;
    vm.getRemoteControlSessions = RemoteControlService.getRemoteControlSessions;
    vm.getRemoteControlSessionDeviceInfo = getRemoteControlSessionDeviceInfo;
    vm.isRemoteControlSessionRemoving = isRemoteControlSessionRemoving;
    vm.isSessionMe = isSessionMe;
    vm.remoteControlCodeVisible = RemoteControlService.remoteControlCodeVisible;
    vm.remoteControlUsersVisible = RemoteControlService.remoteControlUsersVisible;
    vm.removeRemoteControlSession = removeRemoteControlSession;

    log.info('initializing');

    $scope.$on('IdleTimeout', function() {
        if (confirmPopup) confirmPopup.close();
    });

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        if (toState.name !=='control.remote') {
            if (confirmPopup) confirmPopup.close();
        }
    });

    function formatDuration(timestamp) {
        var defaultThreshold = moment.relativeTimeThreshold('m');
        var defaultRounding = moment.relativeTimeRounding();

        // Adjust moment's duration threshold and rounding to show 
        // "in 60 minutes" rather than the default of 45 minutes appearing as 
        // "in an hour".
        moment.relativeTimeThreshold('m', 61);
        moment.relativeTimeRounding(Math.ceil);
        var duration = moment(timestamp).fromNow();
        moment.relativeTimeThreshold('m', defaultThreshold);
        moment.relativeTimeRounding(defaultRounding);

        return duration;
    }

    function getRemoteControlSessionDeviceInfo(session) {
        if (!angular.isDefined(session.$userAgentParsed)) {
            session.$userAgentParsed = new UAParser(session.userAgent);
        }
        var device = session.$userAgentParsed.getDevice();
        if (!angular.isDefined(device.vendor) && !angular.isDefined(device.model)) {
            return session.$userAgentParsed.getOS().name + ' ' +
            session.$userAgentParsed.getBrowser().name;
        }
        return (device.vendor ? device.vendor + ' ' : '') + (device.model ? device.model : '');
    }

    function isRemoteControlSessionRemoving(session) {
        return session.$isRemoving === true;
    }

    function isSessionMe(session) {
        return RemoteControlService.getMyRemoteControlSessionId() === session.$id;
    }

    function removeRemoteControlSession(session) {
        var standardMsg = '<p>' +
            /// Confirmation message for removing remote control session
            gettextCatalog.getString('Are you sure you want to remove the ' + 
            'remote control session {{sessionName}}?', { sessionName: session.ipAddress }) +
            '</p>';
        var isMeMsg = '<p>' +
            /// Confirmation message for removing user's own remote control session (part 1/2)
            gettextCatalog.getString('This is your remote control session. If you ' +
            'remove it, you won\'t be able to control the room.') +
            '</p>' +
            '<p>' +
            /// Confirmation message for removing user's own remote control session (part 2/2)
            gettextCatalog.getString('Are you sure you want to remove it?') +
            '</p>';
        confirmPopup = $ionicPopup.confirm({
                /// Confirmation dialog text for room power off function
                template: isSessionMe(session) ? isMeMsg : standardMsg,
                /// Confirmation dialog 'OK' button text for remove remote control session
                okText: gettextCatalog.getString('Remove'),
                okType: 'button-card-highlight',
                /// Confirmation dialog 'Cancel' button text for remove remote control session
                cancelText: gettextCatalog.getString('Cancel')
            });

        confirmPopup.then(function(response) {
            if (response && !session.$isRemoving) {
                session.$isRemoving = true;
                session.$remove().then(function() {
                    delete session.$isRemoving;
                });
            }
        });
    }
}

module.exports = RemoteControlSessionsController;